module.exports = __webpack_public_path__ + "media/newstyle/images/diners-c7533dd7828f48f2e7157f7c021d3c01.svg";